module.exports = __webpack_public_path__ + "img/pic-YuanitaTjia.6e260db5.png";